<div class="container">
  <div class="sidebar">
    <h2 i18n>Categories</h2>
    <hr>
    <ul>
      <li [class.active]="selectedCategory === 'All'" (click)="selectCategory('All')"
        (keydown)="onKeyPress($event, 'All')" i18n>All</li>

      @for(category of details?.categories; track category) {
      <li [class.active]="selectedCategory === category.name" (click)="selectCategory(category.name)"
        (keydown)="onKeyPress($event, category.name)">
        {{ category.name }}
      </li>
      }
    </ul>
  </div>
  <div class="content" [ngClass]="{ 'hide-dealer-image': dealerImageDisplay }" (swipeleft)="onSwipeLeft($event)"
    (swiperight)="onSwipeRight($event)" (click)="onTabHeaderArrowClick($event)">
    <mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedIndexChange)="selectTab($event)" fitInkBarToContent>
      <mat-tab [label]="pendingTabLabel"></mat-tab>
      <mat-tab [label]="criticalTabLabel"></mat-tab>
      <mat-tab [label]="cautionTabLabel"></mat-tab>
      <mat-tab [label]="checkedTabLabel"></mat-tab>
    </mat-tab-group>

    <div class="scrollable-section">
       <!-- vehicle walkthrough enabled job -->
      @if(walkthroughJob) {
      <div class="card">
        <div class="card-content">
          <div class="card-header">
            <span>{{ walkthroughJob.categoryName }}</span>
            <span [class]="walkthroughJob?.status === jobStatus.OK ? 'green-badge' : 'yellow-badge'">
              {{ walkthroughJob?.status === jobStatus.OK ? 'Checked and OK' : 'Caution' }}
            </span>

          </div>
          <h3>{{ walkthroughJob.description }}</h3>
          <span>{{ walkthroughJob.comment }}</span>
          @if (walkthroughJob?.serviceJobs?.[0]?.descriptionLong) {
          <div class="description-long">
            {{ walkthroughJob?.serviceJobs[0]?.descriptionLong }}
          </div>
          }
        </div>

        <div class="image">
          @if (walkthroughJob?.media) {
          <app-media-carousel [media]="walkthroughJob.media"
            [isWalkthroughEnabled]="walkthroughJob.isWalkthroughEnabled"
            [introOutroMediaData]="introOutroMediaData"></app-media-carousel>
          }
        </div>

        <div class="job-card">
          <div class="card-job-content">
            @if(walkthroughJob?.serviceJobs?.length > 0) {
            <p class="bold">{{ walkthroughJob.solution?.description }}</p>
            }
            @if (walkthroughJob?.serviceJobs?.length > 0) {
            <div class="price-details">
              @for (serviceJob of walkthroughJob.serviceJobs; track serviceJob) {
              @if (serviceJob?.priceSummary?.length > 0) {
              @for (price of serviceJob.priceSummary; track price) {
              <div>
                <span>{{ priceTypeLabel(price?.type)}}</span>
                <span>{{ price?.price?.netPrice | currency: getCurrency(serviceJob.priceSummary): 'symbol-narrow' }}</span>
              </div>
              }
              }
              }
              <div>
                <span i18n>Discount</span>
                <span>{{ getTotalDiscount(walkthroughJob.serviceJobs[0]?.priceSummary) | currency: getCurrency(walkthroughJob.serviceJobs[0]?.priceSummary): 'symbol-narrow' }}</span>
              </div>
              <div class="total">
                <span i18n>Total incl. tax</span>
                <span>{{ getTotalGrossPrice(walkthroughJob.serviceJobs[0]?.priceSummary) | currency: getCurrency(walkthroughJob.serviceJobs[0]?.priceSummary): 'symbol-narrow' }}</span>
              </div>
            </div>
            }
            @if (walkthroughJob?.serviceJobs?.length > 0) {
            <div class="actions">
              @if (walkthroughJob?.serviceJobs[0]?.approvalStatus !==  Approvalstatus.Accept) {
              @if (walkthroughJob?.serviceJobs[0]?.approvalStatus !==  Approvalstatus.Reject) {
              <button mat-button class="decline" (click)="onButtonGroupClick(Approvalstatus.Reject, walkthroughJob)" i18n>
                Decline
              </button>
              } @else {
              <button mat-button class="decline" disabled i18n>
                Declined
              </button>
              }
              }

              @if (walkthroughJob?.serviceJobs[0]?.approvalStatus !== Approvalstatus.Reject) {
              @if (walkthroughJob?.serviceJobs[0]?.approvalStatus !== Approvalstatus.Accept) {
              <button mat-button color="primary" class="authorize"
                (click)="onButtonGroupClick(Approvalstatus.Accept, walkthroughJob)" i18n>
                Authorize
              </button>
              } @else {
              <button mat-button color="primary" class="authorize" disabled i18n>
                Authorized
              </button>
              }
              }
            </div>
            }
          </div>
        </div>
      </div>
      }

      <!-- Cards for Checkpoint Jobs -->
      @if(checkpointJobs?.length > 0){
      <div>
        @for( job of checkpointJobs; track job.id; let i= $index) {
        <div class="card">
          <div class="card-content">
            <div class="card-header">
              <span>{{ job.categoryName }}</span>
                  <span [ngClass]="getBadgeClass(job)">
                        {{ getBadgeLabel(job) }}
                  </span>
            </div>
            <h3>{{ job?.description }}</h3>
            <span>{{ job?.comment }}</span>
            @if (job?.serviceJobs?.[0]?.descriptionLong) {
            <div class="description-long">
              {{ job?.serviceJobs[0]?.descriptionLong }}
            </div>
            }
            @if (job?.measuredValues?.length > 0) {
                <div>
                    {{ job.measuredValues[0].value }}
                </div>
              }          
          </div>

          <div class="image">
            @if (job?.media) {
            <app-media-carousel id="{{i}}" [media]="job.media" [isWalkthroughEnabled]="job.isWalkthroughEnabled"
              [introOutroMediaData]="introOutroMediaData"></app-media-carousel>
            }
            @if (job?.measuredValues?.length > 0 && job.measuredValues[0]?.media?.length > 0) {
            <app-media-carousel id="{{i}}" [media]="job?.measuredValues[0]?.media" [isWalkthroughEnabled]="job.isWalkthroughEnabled"
              [introOutroMediaData]="introOutroMediaData"></app-media-carousel>
            }
          </div>
          <div class="job-card">
            <div class="card-job-content">
              @if(job?.serviceJobs?.length > 0){
              <p class="bold">{{ job.solution?.description }}</p>
              }
              @if (job?.serviceJobs?.length > 0) {
              <div class="price-details">
                @for (serviceJob of job.serviceJobs; track serviceJob) {
                @if (serviceJob?.priceSummary?.length > 0) {
                @for (price of serviceJob.priceSummary; track price) {
                <div>
                  <span>{{ priceTypeLabel(price?.type)}}</span>
                  <span>{{ price?.price?.netPrice | currency: getCurrency(serviceJob.priceSummary): 'symbol-narrow'}}</span>
                </div>
                }
                }
                }
                <div><span i18n>Discount</span> <span>
                    {{ getTotalDiscount(job.serviceJobs[0]?.priceSummary) | currency: getCurrency(job.serviceJobs[0]?.priceSummary): 'symbol-narrow' }}</span>
                </div>
                <div class="total">
                  <span i18n>Total incl. tax</span>
                  <span>
                    {{ getTotalGrossPrice(job.serviceJobs[0]?.priceSummary) | currency: getCurrency(job.serviceJobs[0]?.priceSummary): 'symbol-narrow' }}
                  </span>
                </div>
              </div>
              }
              @if (job?.serviceJobs?.length > 0) {
              <div class="actions">
                @if (job?.serviceJobs[0]?.approvalStatus !== Approvalstatus.Accept) {
                @if (job?.serviceJobs[0]?.approvalStatus !== Approvalstatus.Reject) {
                <button mat-button class="decline" (click)="onButtonGroupClick(Approvalstatus.Reject,job)" i18n>
                  Decline
                </button>
                } @else {
                <button mat-button class="decline" disabled i18n>
                  Declined
                </button>
                }
                }

                @if (job?.serviceJobs[0]?.approvalStatus !== 'Reject') {
                @if (job?.serviceJobs[0]?.approvalStatus !== 'Accept') {
                <button mat-button color="primary" class="authorize" (click)="onButtonGroupClick(Approvalstatus.Accept,job)" i18n>
                  Authorize
                </button>
                } @else {
                <button mat-button color="primary" class="authorize" disabled i18n>
                  Authorized
                </button>
                }
                }
              </div>
              <div class="extra-space"></div>
              }
            </div>
          </div>
        </div>
        }
      </div>
      }

      <!-- Cards for Findings Jobs  -->
      @if (filteredFindingsJobs?.length > 0 && selectedTab !== 'checked') {
      <div>
        @for (job of filteredFindingsJobs; track job; let i = $index) {
        <div class="card">
          <div class="card-content">
            <div class="card-header">
              <span>{{ job.categoryName }}</span>
              @if (job.findingColor === findingColors.critical) {
              <span class="red-badge" i18n>Critical</span>
              }
              @if (job.findingColor === findingColors.caution) {
              <span class="yellow-badge" i18n>Caution</span>
              }
            </div>
            <h3>{{ job?.checkpointName }}</h3>
            <p class="bold">{{ job.findingType?.description }}</p>
            <span>{{ job?.comment }}</span>
            @if (job?.serviceJobs?.[0]?.descriptionLong) {
            <div class="description-long">
              {{ job?.serviceJobs[0]?.descriptionLong }}
            </div>
            }
          </div>
          <div class="image">
            @if (job?.media) {
            <app-media-carousel [media]="job.media" id="{{i}}"
              [introOutroMediaData]="introOutroMediaData"></app-media-carousel>
            }
          </div>
          <div class="job-card">
            <div class="card-job-content">
              @if (job?.serviceJobs?.length > 0) {
              <p>{{ job.solution?.description }}</p>
              }
              @if (job?.serviceJobs?.length > 0) {
              <div class="price-details">
                @for (serviceJob of job.serviceJobs; track serviceJob) {
                @if (serviceJob?.priceSummary?.length > 0) {
                @for (price of serviceJob.priceSummary; track price) {
                <div>
                 <span>{{ priceTypeLabel(price?.type)}}</span>
                  <span>{{ price?.price?.netPrice  | currency: getCurrency(serviceJob.priceSummary): 'symbol-narrow'}}</span>
                </div>
                }
                }
                }
                <div><span i18n>Discount</span> <span>
                    {{ getTotalDiscount(job.serviceJobs[0]?.priceSummary) | currency: getCurrency(job.serviceJobs[0]?.priceSummary): 'symbol-narrow' }}</span>
                </div>
                <div class="total">
                  <span i18n>Total incl. tax</span>
                  <span>
                    {{ getTotalGrossPrice(job.serviceJobs[0]?.priceSummary) | currency: getCurrency(job.serviceJobs[0]?.priceSummary): 'symbol-narrow' }}
                  </span>
                </div>
              </div>
              }
              @if (job?.serviceJobs?.length > 0) {
              <div class="actions">
                @if (job?.serviceJobs[0]?.approvalStatus !== Approvalstatus.Accept) {
                @if (job?.serviceJobs[0]?.approvalStatus !== Approvalstatus.Reject) {
                <button mat-button class="decline" (click)="onButtonGroupClick(Approvalstatus.Reject, job)" i18n>
                  Decline
                </button>
                } @else {
                <button mat-button class="decline" disabled i18n>
                  Declined
                </button>
                }
                }

                @if (job?.serviceJobs[0]?.approvalStatus !== Approvalstatus.Reject) {
                @if (job?.serviceJobs[0]?.approvalStatus !== Approvalstatus.Accept) {
                <button mat-button color="primary" class="authorize" (click)="onButtonGroupClick(Approvalstatus.Accept, job)" i18n>
                  Authorize
                </button>
                } @else {
                <button mat-button color="primary" class="authorize" disabled i18n>
                  Authorized
                </button>
                }
                }

              </div>
              <div class="extra-space"></div>
              }
            </div>
          </div>
        </div>
        }
      </div>
      }

      @if (!(checkpointJobs?.length > 0 || filteredFindingsJobs?.length > 0 || walkthroughJob)) {
      <div class="no-data-wrapper">
        <div class="no-data-container">
          <img src="assets/logo/search_off.jpg" alt="No Data Available" />
          <div class="no-jobs-container">
            <h3>{{ getNoJobsMessage().title }}</h3>
            <p>{{ getNoJobsMessage().description }}</p>
          </div>
        </div>
      </div>
      }
    </div>
  </div>

  <div class="footer" *ngIf="showFooter">
    <div class="footer-content">
      @if (showDeclineButton && !isAuthorized) {
      <button class="decline-all-button" color="primary" mat-raised-button [disabled]="isDeclineDisabled"
        [ngClass]="{'disabled-button': isDeclineDisabled || (totalPendingJobsCount ?? 0) <= 1}"
        (click)="onApproveAllOrDeclineAllClick(Approvalstatus.Reject)">
        <span i18n>Decline All</span>
        <mat-icon>close</mat-icon>
      </button>
      }

      @if (!isAuthorized) {
      <button class="request-callback-button" color="primary" mat-raised-button
        (click)="onApproveAllOrDeclineAllClick(Approvalstatus.NotProvided)">
        <span class="callback-text" i18n>Request Callback</span>
        <mat-icon class="callback-icon">phone_in_talk</mat-icon>
      </button>
      }

      @if (showAuthorizeButton) {
      <button class="button-authorize" color="primary" mat-raised-button [disabled]="isAuthorizeDisabled"
        [ngClass]="{'disabled-button': isAuthorizeDisabled || (totalPendingJobsCount ?? 0) <= 1}"
        (click)="onApproveAllOrDeclineAllClick(Approvalstatus.Accept)">
        <span i18n>Authorize All</span>
        <mat-icon>check</mat-icon>
      </button>
      }
    </div>

    <div class="action-bar-container responsive-actions">
      @if (!isAuthorized) {
      <button class="floating-center-btn" (click)="onApproveAllOrDeclineAllClick(Approvalstatus.NotProvided)">
        <mat-icon class="callback-icon">phone_in_talk</mat-icon>
      </button>
      }
      <div class="action-bar">
        @if (showDeclineButton && !isAuthorized) {
        <button mat-button class="decline-btn" [disabled]="isAuthorizeDisabled || (totalPendingJobsCount ?? 0) <= 1"
          [ngClass]="{'text-disabled': isDeclineDisabled || (totalPendingJobsCount ?? 0) <= 1}"
          (click)="onApproveAllOrDeclineAllClick(Approvalstatus.Reject)">
          <mat-icon>close</mat-icon>
          <span>Decline all</span>
        </button>
        }
        @if (showAuthorizeButton) {
        <button mat-button class="authorize-btn" [disabled]="isAuthorizeDisabled || (totalPendingJobsCount ?? 0) <= 1"
          [ngClass]="{'text-disabled': isAuthorizeDisabled || (totalPendingJobsCount ?? 0) <= 1}"
           (click)="onApproveAllOrDeclineAllClick(Approvalstatus.Accept)">
          <mat-icon>check</mat-icon>
          <span>Authorize all</span>
        </button>
        }
      </div>
    </div>
  </div>
</div>